export const ITEMS_PER_PAGE = 25;

export const PAGE_OPTIONS = {
  buttonCount: 5,
  pageSizes: [10, 25, 50, 100],
  initialPageSize: ITEMS_PER_PAGE,
};
